module.exports = __webpack_public_path__ + "img/menuIcon12.be0e8c35.png";